/*eslint-disable*/
import React from "react"
// react components for routing our app without refresh
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"
import List from "@material-ui/core/List"
import ListItem from "@material-ui/core/ListItem"
// @material-ui/icons
// core components
import Button from "../../components/CustomButtons/Button.jsx"

import headerLinksStyle from "../../assets/jss/material-kit-react/components/headerLinksStyle.jsx"

class HeaderLinks extends React.Component {
    constructor(props) {
        super(props)
        this.headerColorChange = this.headerColorChange.bind(this)
        this.handleClasses = this.handleClasses.bind(this)
    }

    componentDidMount() {
        window.addEventListener("scroll", this.headerColorChange)
    }

    handleClasses(id) {
        const windowsScrollTop = window.pageYOffset
        if (windowsScrollTop > 200) {
            document.getElementById(id).classList.remove("default")
            document.getElementById(id).classList.add("inverse")
        } else {
            document.getElementById(id).classList.add("default")
            document.getElementById(id).classList.remove("inverse")
        }
    }

    headerColorChange() {
        this.handleClasses("about-button")
        this.handleClasses("works-button")
        this.handleClasses("learn-button")
        this.handleClasses("contact-button")
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.headerColorChange)
    }

    render() {
        const { classes } = this.props
        return (
            <List className={classes.list}>
                <ListItem className={classes.listItem}>
                    <Button id="about-button" href="#home" color="transparent" className={classes.navLink}>
                        Home
                    </Button>
                </ListItem>
                <ListItem className={classes.listItem}>
                    <Button id="works-button" href="#features" color="transparent" className={classes.navLink}>
                        Features
                    </Button>
                </ListItem>
                <ListItem className={classes.listItem}>
                    <Button id="learn-button" href="#pricing" color="transparent" className={classes.navLink}>
                        Pricing
                    </Button>
                </ListItem>
                <ListItem className={classes.listItem}>
                    <Button id="sign-up-button" href="#contactForm" color="transparent" className={classes.navLink}>
                        <span style={{ color: "#FFC915" }}>Sign Up</span>
                    </Button>
                </ListItem>

                <ListItem className={classes.listItem}>
                    <Button id="contact-button" color="transparent" href="#contact" className={classes.navLink}>
                        Contact Us
                    </Button>
                </ListItem>
            </List>
        )
    }
}

export default withStyles(headerLinksStyle)(HeaderLinks)



// WEBPACK FOOTER //
// ./src/components/Header/HeaderLinks.jsx